import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { AppComponent } from './app/app';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

// No-ops without a DSN (local dev / unconfigured environments).
if (environment.sentryDsn) {
	Sentry.init({
		dsn: environment.sentryDsn,
		environment: environment.sentryEnvironment,
		enableLogs: true,
	});
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
